import { TabRoute } from "src/components/pageTabs";
import { ChatPlatform } from "src/gen/schema/models/chatbot";

/**
 * User and Bot Management section navigation tabs
 * Used in the UserAndBotLayout component
 */
export const getUserAndBotTabs = (): TabRoute[] => {
  return [
    {
      header: "Users",
      url: "/user-management",
      name: "users",
      qaData: "user-management-tab"
    },
    {
      header: "Bots",
      url: "/bot-management",
      name: "bots",
      qaData: "bot-management-tab"
    }
  ];
};

/**
 * Administration route paths
 */
export const USER_AND_BOT_PATHS = {
  USER_MANAGEMENT: "/user-management",
  BOT_MANAGEMENT: "/bot-management"
} as const;

/**
 * Provider identifier for bot, external and regular users
 */
export const BOTS_PROVIDER = "BOTS";
export const CISCO_PROVIDER = "CISCO";
export const EXTERNAL_PROVIDER = "REMOTE";

/**
 * Platform-specific configuration for bot invitations
 */
interface PlatformConfig {
  readonly label: string;
  readonly qaData: string;
}
/**
 * Platform-specific configuration for bot invitations
 */
export const PLATFORM_INVITATION_CONFIG: Record<
  ChatPlatform,
  PlatformConfig | undefined
> = {
  [ChatPlatform.UNRECOGNIZED]: undefined,
  [ChatPlatform.PLATFORM_UNSPECIFIED]: undefined,
  [ChatPlatform.PLATFORM_DISCORD]: {
    label: "Copy Discord bot link",
    qaData: "copy-discord-bot-link"
  },
  [ChatPlatform.PLATFORM_WEBEX]: {
    label: "Copy Webex bot ID",
    qaData: "copy-webex-bot-id"
  },
  [ChatPlatform.PLATFORM_SLACK]: undefined,
  [ChatPlatform.PLATFORM_MS_TEAMS]: undefined
};

/**
 * Bot setup workflow steps
 * Defines the 4-step process for setting up a bot user
 */
export const BOT_SETUP_STEPS = [
  {
    stepNumber: 1,
    title: "Add bot user",
    description: "Add bot user to enter a bot user name.",
    descriptionHighlightText: "Add bot user",
    badgeText: "Admin",
    iconName: "bot",
    completedText: "Done in Nexus Hyperfabric.",
    badgeClassName: "admin-badge"
  },
  {
    stepNumber: 2,
    title: "Invite Hyperfabricbot",
    description:
      "Share bot link with app user to add Hyperfabricbot to the messaging platform.",
    descriptionHighlightText: "Share bot link",
    badgeText: "Admin",
    iconName: "share-bot",
    badgeClassName: "admin-badge"
  },
  {
    stepNumber: 3,
    title: "Get binding code",
    description:
      "Message Hyperfabricbot in the chat room to get the binding code.",
    descriptionHighlightText: "",
    badgeText: "App user",
    iconName: "bot-key",
    badgeClassName: "app-user-badge"
  },
  {
    stepNumber: 4,
    title: "Bind bot user",
    description:
      "Bind bot user to enter the binding code and link the bot user to the chat room.",
    descriptionHighlightText: "Bind bot user",
    badgeText: "Admin",
    iconName: "bind-bot",
    completedText: "Done in Nexus Hyperfabric.",
    badgeClassName: "admin-badge"
  }
] as const;
